import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import placeholderBackground from "../../../assets/images/placeholder-background.png";

import { config } from "../../../config";

const { SERVER_URL } = config;

const ItemCard = ({ history, item, setActiveItem }) => {
  const [quantityLeft, setQuantityLeft] = useState(0);

  useEffect(() => {
    let total = item.redeemed.reduce(
      (total, redeem) => total + redeem.quantity,
      0
    );
    setQuantityLeft(item.quantity - total);
  }, [item]);

  return (
    <>
      <div className="bg-white shadow">
        <div
          className="imageHover"
          onClick={() => history.push(`/rewards/item/${item.id}`)}
          style={{
            position: "relative",
            backgroundImage: `url(${
              item.images.length > 0
                ? `${SERVER_URL}/${item.images[0].url}`
                : placeholderBackground
            })`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
            height: "120px",
          }}
        >
          {quantityLeft <= 0 ? (
            <div
              style={{
                height: "20px",
                position: "absolute",
                bottom: "0",
                fontSize: "0.75rem",
                background: "#dd7b7c",
              }}
              className="w-100 text-center text-white"
            >
              FULLY REDEEMED
            </div>
          ) : (
            <div
              style={{
                height: "20px",
                position: "absolute",
                bottom: "10px",
                right: "10px",
                fontSize: "0.75rem",
                borderRadius: "500px",
                width: "auto",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
              }}
              className="text-center text-white bg-brand"
            >
              {quantityLeft} Left
            </div>
          )}
        </div>
        <div className="py-2 px-3">
          <div className="d-flex flex-column">
            <h6 className="p-0 m-0">{_.truncate(item.name, { length: 28 })}</h6>
            <div className="text-brand mt-1" style={{ fontSize: "0.8rem" }}>
              {item.type === "redeemable"
                ? `${item.redeem_points} POINTS`
                : "FREE"}
            </div>
          </div>
          <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
          <button
            disabled={quantityLeft <= 0}
            className="btn btn-design btn-brand btn-block"
            onClick={() => setActiveItem(item)}
          >
            {quantityLeft <= 0 ? "Unavailable" : "Redeem"}
          </button>
        </div>
      </div>
    </>
  );
};

export default withRouter(ItemCard);
